import { render, staticRenderFns } from "./AlertsMessagesComponent.vue?vue&type=template&id=65a5393e&scoped=true"
import script from "./AlertsMessagesComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsMessagesComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertsMessagesComponent.vue?vue&type=style&index=0&id=65a5393e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5393e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a5393e')) {
      api.createRecord('65a5393e', component.options)
    } else {
      api.reload('65a5393e', component.options)
    }
    module.hot.accept("./AlertsMessagesComponent.vue?vue&type=template&id=65a5393e&scoped=true", function () {
      api.rerender('65a5393e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertsMessages/AlertsMessagesComponent.vue"
export default component.exports